export default {
    langType: '简体',
    public_head: {
        home: '首页',
        cart: '购物车',
        account_setting: '账户设置',
        categories: '所有类别',
        coffee: '迅猫啡',
        hotsale: '热卖商品',
        special_offer: '特惠活动',
        machine_location: '机台位置',
        about_us: '关于我们',
        contact_us: '联系我们',
        please_sign: '你好，请登录',
        register: '免费注册',
        welcome: '欢迎您，',
        personal_center: '个人中心',
        logout: '退出账号',
        favorites: '收藏夹',
        help_center: '帮助中心',
        macao: '中国澳门',
        mainland: '中国大陆',
        tips: '温馨提示',
        tips_content: '确认退出账号吗？',
        cancel_text: '取消',
        confirm_text: '确定',
        points_mall: '积分商城',
        card_buy: '超值卡'
    },
    goods: {
        settle: '去结算',
        add_cart: '加入购物车',
        no_data: '暂无获取到相对应数据！',
        Recommended_products: '推荐商品',
        more: '查看更多',
        limit_buy: '立即抢购',
        sold_out: '已售空',
        all_goods: '所有商品',
        classify: '分类',
        brand: '品牌',
        stock: '库存',
        unit: '件',
        integral: '积分'
    },
    merchant_promise: {
        text1: '百万用户口碑',
        text2: '品牌防伪码',
        text3: '值得信赖品牌',
        text4: '品类齐全',
        text5: '精致服务',
        text6: '天天特价'
    },
    pay: {
        payment_method: '选择支付方式',
        hide_payment_methode_: '收起支付方式',
        more_payment_method: '更多支付方式',
        payment: '立即支付'
    },
    public_footer: {
        text1: '品牌真品防伪码',
        text2: '专属客服服务 853-63005007',
        text3: '© 2009-2022 迅猫先锋 版权所有 ',
        link: '粤ICP备2021154733号'
    },
    forget: {
        forgot_pwd: '忘记密码',
        phone: '手机号码',
        your_phone_tips: '请输入你的手机号码',
        phone_tips: '请输入手机号码',
        phone_regular_tips: '请输入正确的手机号码',
        code: '验证码',
        code_tips: '请输入验证码',
        get_code: '获取验证码',
        sent: '已发送',
        new_pwd: '新密码',
        confirm_pwd: '密码确认',
        edit_pwd: '修改密码',
        pwd_tips: '请输入密码',
        pwd_regular_tips: '请输入6-18位字母、数字组合!',
        pwd_confirm_tips: '请再次输入密码',
        pwd_confirm_check_tips: '两次输入密码不一致',
        reset_pwd: '密码重置完成，前往登录',
        tips: '温馨提示',
        cancel_text: '取消',
        confirm_text: '确定',
    },
    login: {
        pwd_login: '密码登录',
        code_login: '短信登录',
        scan_code_login: '微信扫码登录',
        phone: '手机号码',
        phone_tips: '请先输入手机号码',
        code_tips: '请输入验证码',
        get_code: '获取验证码',
        pwd_tips: '请输入密码',
        login: '登录',
        protocol_text1: '登录代表您已同意',
        protocol_text2: '《迅貓先鋒用户协议》',
        protocol_text3: '和',
        protocol_text4: '《隐私协议》',
        forget_pwd: '忘记密码',
        register: '免费注册',
        phone_regular_tips: '请输入正确的手机号码',
        sent: '已发送',
    },
    register: {
        user_register: '用户注册',
        phone: '手机号码',
        your_phone_tips: '请输入你的手机号码',
        phone_tips: '请输入手机号码',
        phone_regular_tips: '请输入正确的手机号码',
        code: '验证码',
        code_tips: '请输入验证码',
        get_code: '获取验证码',
        sent: '已发送',
        pwd: '密码',
        confirm_pwd: '密码确认',
        pwd_tips: '请输入密码',
        protocol_text1: '注册代表您已同意',
        protocol_text2: '《迅貓先鋒用户协议》',
        protocol_text3: '和',
        protocol_text4: '《隐私协议》',
        protocol_text5: '同意并注册',
        pwd_regular_tips: '请输入6-18位字母、数字组合!',
        pwd_confirm_tips: '请再次输入密码',
        pwd_confirm_check_tips: '两次输入密码不一致',
        register_success_tips: '注册成功，前往登录?',
        tips: '温馨提示',
        cancel_text: '取消',
        confirm_text: '确定',
    },
    cart: {
        home: '首页',
        shop_cart: '购物车',
        title_row1: '商品信息',
        title_row2: '单价',
        title_row3: '数量',
        title_row4: '金额',
        title_row5: '操作',
        original_price: '原价',
        delete: '删除',
        empty: '清空购物车',
        allselect: '全选',
        total: '合计',
        settle: '结算',
        select_tips: '请选择商品',
        modal_text1: '确认清空购物车吗?',
        modal_text2: '确认将该商品移除购物车吗?',
        tips: '温馨提示',
        cancel_text: '取消',
        confirm_text: '确定',
        go_to_mall: '前往商城',
        empty_tips: '主人，您的购物车还没有商品哟~',
        vemid: '设备ID'
    },
    machine: {
        home: '首页',
        machine_location: '机台位置',
        location: '导航',
        cart: '购物车',
        back: '返      回',
        no_data: '暂无获取到相对应数据！',
        area: '区域',
        default: '默认',
        distance_text1: '由远到近',
        distance_text2: '由近到远',
        all: '全部',
        vending_machine: '售卖机',
        coffee_machine: '迅猫啡',
        machine_no: '机器编号'
    },
    member: {
        member_card_number: '会员卡号',
        my_order: '我的订单',
        order_text1: '所有订单',
        order_text2: '待付款',
        order_text3: '待自提',
        order_text4: '已取消',
        order_text5: '已完成',
        btn_tit: '常用功能',
        btn_text1: '积分商城',
        btn_text2: '我的收藏',
        btn_text3: '联系客服',
        btn_text4: '关于我们',
        btn_text5: '退出账号',
        btn_text6: '我的卡包',
        tips: '温馨提示',
        tips_content: '确认退出账号吗？',
        cancel_text: '取消',
        confirm_text: '确定',
        coupon: '我的优惠券',
        coupon_title: '优惠券',
        points: '积分'
    },
    member_info: {
        basic_info: '基础资料',
        avatar: '头像',
        nickname: '昵称',
        nickname_tips: '请输入昵称',
        sex: '性别',
        unknown: '未知',
        male: '男',
        female: '女',
        security_settings: '安全设置',
        user_account: '用户账号',
        login_pwd: '登录密码',
        edit_pwd: '修改密码',
        phone: '手机号码',
        change_tie: '换绑',
        save: '保存',
        reset_pwd: '重置密碼',
        phone_tips: '请输入手机号码',
        code: '验证吗',
        get_code: '获取验证码',
        sent: '已发送',
        pwd: '密码',
        confirm_pwd: '密码确认',
        protocol_text1: '登录代表您已同意',
        protocol_text2: '《迅貓先鋒用户协议》',
        protocol_text3: '和',
        protocol_text4: '《隐私协议》',
        change_tie_phone: '换绑手机',
        your_phone_tips: '请输入你的手机号码',
        previous: '上一步',
        next_step: '下一步',
        pwd_tips: '请输入密码',
        pwd_confirm_tips: '请再次输入密码',
        pwd_confirm_check_tips: '两次输入密码不一致',
        phone_check_tips: '请输入正确的手机号码',
        upload_tips: '只能上传 jpeg/jpg/png 格式文件',
        tips: '温馨提示',
        tips_content: '密码重置完成，请重新登录账号',
        cancel_text: '取消',
        confirm_text: '确定',
    },
    user_order: {
        title_row1: '商品',
        title_row2: '单价',
        title_row3: '数量',
        title_row4: '商品操作',
        title_row5: '实付款',
        title_row6: '交易状态',
        title_row7: '交易操作',
        orderno: '订单号',
        self_code: '自提码',
        distance: '距离',
        original_price: '原价',
        redemption_code: '兑换码',
        Including_shipping: '含运费',
        states_text1: '待付款',
        states_text2: '待自提',
        states_text3: '配送中',
        states_text4: '已完成',
        states_text5: '已取消',
        states_text6: '退款/售后',
        order_detail: '订单详情',
        settle: '去结算',
        cancel_order: '取消订单',
        delete_order: '删除订单',
        no_related_orders: '暂无相关订单',
        empty_tips: '主人，您近期还没有购买任何商品哟~',
        empty_btn: '前往商城',
        code_text1: '请截图保存下方取货兑换码',
        code_text2: '并且30天内到已选定的机台取货',
        code_text3: '兑换码',
        payments: '支付进行中',
        view_order_detail: '查看订单详情',
        tips: '温馨提示',
        cancel_tips: '确认取消该订单吗？',
        delete_tips: '确认删除该订单吗？',
        refund_tips: '确认退款该订单吗？',
        cancel_text: '取消',
        confirm_text: '确定',
        point: '积分',
        refund_status: '退款状态',
        exchange: '兑换',
        has_been: '已于',
        vemid: '设备ID'
    },
    help: {
        home: '首页',
        help_center: '帮助中心'
    },
    order_confirm: {
        checkout_page: '结算页',
        fill_tips: '填写并核对订单信息',
        default: '默认',
        paytype: '支付方式',
        goods_list: '商品清单',
        putaway: '收起',
        expand: '展开',
        original_price: '原价',
        amount: '商品金额',
        total: '实付款',
        payments: '支付中…',
        settle: '去结算',
        payments_progress: '支付进行中',
        view_order_detail: '查看订单详情',
        pickup: '自提',
        coupon: '优惠券',
        edit: '修改',
        coupon_available: '张可用',
        no_available: '暂无可用',
        no_use: '不使用优惠券',
		validity_period: '有效期至',
		full_text: '满',
		available: '可用',
        select_coupon: '选择优惠券',
        pay_tips: '如无法正常支付，请检查您的浏览器设置，是否拦截弹窗，请修改设定后回到订单页面尝试重新支付，如仍有问题，请及时与我们客服工作人员联系，感谢您的配合与谅解。',
        integral: ' 积分',
        paypoint: '支付积分',
        card_txt1: '是否赠送好友',
		card_txt2: '是',
		card_txt3: '否',
		card_txt4: '填写好友会员手机号',
		card_txt5: '请输入手机号',
    },
    order_detail: {
        title: '订单详情',
        order_status: '订单状态',
        status_text1: '待付款',
        status_text2: '待自提',
        status_text3: '配送中',
        status_text4: '已完成',
        status_text5: '已取消',
        status_text6: '退款/售后',
        distance: '距离',
        goods_list: '商品清单',
        redemption_code: '兑换码',
        putaway: '收起',
        expand: '展开',
        code_text1: '请截图保存下方取货兑换码',
        code_text2: '并且24小时内到已选定的机台取货',
        code_text3: '兑换码',
        code_text4: '并且30天内到已选定的机台取货',
        payment_method: '支付方式',
        delivery_method: '配送方式',
        home_delivery: '配送上门',
        pickup: '售卖机自提',
        orderno: '订单编号',
        orderno_time: '下单时间',
        pay_time: '支付时间',
        amount: '商品金额',
        payable: '需付款',
        total: '实付款',
        settle: '去结算',
        cancel_order: '取消订单',
        payments: '支付进行中',
        view_order_detail: '查看订单详情',
        tips: '温馨提示',
        cancel_tips: '确认取消该订单吗？',
        refund_tips: '确认退款该订单吗？',
        cancel_text: '取消',
        confirm_text: '确定',
        not_order: '订单不存在',
        coupon: '优惠券',
        point: '积分',
        refund_status: '退款状态',
        exchange: '兑换',
        has_been: '已于',
        refund_status_text: '退款审核状态',
		refund_pay_text: '退款到账状态',
		refund_amount: '退款金额',
        integral: ' 积分',
        paypoint: '支付积分',
        vemid: '设备ID',
        close: '关闭',
        send_friend: '赠送好友',
        card_num1: '总数量',
		card_num2: '待兑换数量',
		card_change: '切换'
    },
    coupon: {
        validity_period: '有效期至',
		full_text: '满',
		available: '可用',
		receive: '立即领取',
		receive_success: '领取成功',
		settle: '去结算',
		sold_out: '已售空',
        use_desc: '使用描述'
    },
    goods_info: {
        home: '首页',
        goods_detail: '商品详情',
        all_goods: '所有商品',
		notice: '购物须知',
		add_cart: '加入购物车',
		buy: '立即购买',
		stock: '库存',
		unit: '件',
		num: '数量',
		confirm_text: '确认',
		select_text: '已选',
		unfold: '展开',
		pickup: '收起',
		vend_title: '售卖机',
		location: '导航',
		notice_content: '商品的实际标价，不因表达的差异改变性质。具体的成交价格根据商品参加活动，或会员使用优惠券、积分等发生变化最终以订单结算页价格为准。',
		time_limit_title: '限时购',
		time_limit_desc: '限时限量，速速抢购',
		time_limit_tips_start: '距开始仅剩',
		time_limit_tips_conduct: '距结束仅剩',
		time_limit_tips_end: '已结束',
		limit_buy: '立即抢购',
		sale_out: '已售空',
        wechat_scan: '微信扫一扫',
        go_to_mall: '前往商城',
        hot_sale: '热卖商品',
        does_not_exist: '访问的商品不存在~',
        integral: '积分'
	},
    coupon_list: {
		title: '优惠券',
		coupon_state: [{
			states: 0,
			name: '未使用'
		},{
			states: 1,
			name: '已使用'
		},{
			states: 2,
			name: '已过期'
		}],
		loading: '正在加载中',
		nomore: '已经到底了！',
		none_order: '您还没有相关的优惠券',
		desc_text1: '消费满',
		desc_text2: '可用，可减免',
		use_btn: '去使用',
        expired_btn: '已过期',
        use_desc: '使用描述',
        used_btn: '已使用',
		coupon_desc1: '有效期至',
		coupon_desc2: '自助机（自提）可用',
		coupon_desc3: '最终解释权归迅猫先锋所有',
        no_coupon: '暂无相关优惠券',
        all_available: '全场可用',
        part_available: '指定商品可用'
	},
    goods_collect: {
        home: '首页',
        favorites: '收藏夹',
        remove_favorite: '移除收藏夹',
        cancel_batch_management: '取消批量管理',
        batch_management: '批量管理',
        empty_favorites: '清空收藏夹',
        all_select: '全选',
        go_to_mall: '前往商城',
        empty_tips: '主人，您还没有收藏过任何商品哟~',
        tips: '温馨提示',
        clear_tips_content: '确认清空收藏夹吗?',
        remove_tips_content: '确认将选中的商品移除收藏夹吗?',
        cancel_text: '取消',
        confirm_text: '确定',
	},
    points: {
        user_center: '个人中心',
        points_mall: '积分商城',
        integral: '积分',
        exchange: '兑换',
        tips: '温馨提示',
		tips_content: '确认兑换该商品吗？',
		cancel_text: '取消',
		confirm_text: '确定',
        no_data: '暂无获取到相对应数据！',
        exchange_record: '兑换记录',
		check: '查看',
    },
    record: {
        integral_detail: '积分明细',
        exchange_record: '兑换记录',
		rule_desc: '查看规则说明',
		order: '订单编号',
		addtime: '创建时间',
        integral: '积分',
        no_data: '暂无获取到相对应数据！'
    },
    integral_detail: {
        home: '首页',
		points_mall: '积分商城',
		integral: '积分',
		stock: '库存数量',
		exchange: '马上兑换',
		rule: '兑换规则',
		more: '查看更多',
		pickup: '收起',
		unfold: '展开',
		detail: '商品详情',
		unit: '件',
		tips: '温馨提示',
		tips_content: '确认兑换该商品吗？',
		cancel_text: '取消',
		confirm_text: '确定',
		vend_title: '售卖机',
		location: '导航'
	},
    card: {
		detail_title: '详情',
		validity: '有效期',
		day: '天',
		number: '剩余次数',
		times: '次',
		my_card: '我的卡包',
		use_txt1: '已使用',
		use_txt2: '未使用',
		use_txt3: '去使用',
		pop_txt1: '选择咖啡机',
        value: '价值'
	}
}